
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Grid, Table, Dropdown, Button, Icon } from "semantic-ui-react";
import Color from 'color';
import ColorPicker, { SIGNAL_COLORS } from '../ColorPicker';
import PainPointModal from "./PainPointModal";
import { deleteAnnotation, patchAnnotation, fetchAnnotations } from '../../../data/analysis/annotationsActions';

const defaultColors = {
  red: 255,
  green: 255,
  blue: 55,
  alpha: 1
};

const defaultColorPicker = {
  colors: [255,255,255],
  opacity: 1
}

const LabelColor = props => {
  const { red, green, blue, alpha, clickHandler } = props;
  const style = {
    backgroundColor: `rgba(${red},${green},${blue},${alpha})`
  };
  return <div style={style} className="labelColor" onClick={clickHandler} />;
};

LabelColor.propTypes = {
  red: PropTypes.number,
  green: PropTypes.number,
  blue: PropTypes.number,
  alpha: PropTypes.number
};

LabelColor.defaultProps = defaultColors;

class Video extends Component {

  constructor() {
    super();
    this.videoPlayer = React.createRef();
    this.setCurrentTime = this.setCurrentTime.bind(this);
    this.closeColorPicker = this.closeColorPicker.bind(this);
    this.openColorPicker = this.openColorPicker.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.okHandler = this.okHandler.bind(this);

    this.state = {
      colorPickerIsOpen: false,
      colorPickerSelectedSettings: null,
      modalIsOpen: false,
      modalSelectedSettings: null,
      modalMode: null,
      videoDuration: null,
      activePainPoint: null
    };
  }

  componentDidUpdate(prevProps) {
    setTimeout(() => {
      const video = this.videoPlayer.current;
      if (video != null && !isNaN(video.duration) && this.state.videoDuration !== video.duration) {
        this.setState({ videoDuration: video.duration })
      }
    }, 1000);
    if(JSON.stringify(prevProps.painpointArray) !== JSON.stringify(this.props.painpointArray)){
      this.props.dispatch(fetchAnnotations(this.props.activeLayerId, 11));
    }
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
      modalSelectedSettings: null,
      activePainPoint: null
    });
  }

  openModal(colors, mode, painpoint) {
    this.setState({
      modalIsOpen: true,
      modalSelectedSettings: colors,
      modalMode: mode,
      activePainPoint: painpoint
    });
  }
  
  closeColorPicker() {
    this.setState({
      colorPickerIsOpen: false,
      colorPickerSelectedSettings: null,
      activePainPoint: null
    });
  }

  openColorPicker(colors, painPoint) {
    this.setState({
      colorPickerIsOpen: true,
      colorPickerSelectedSettings: colors,
      activePainPoint: painPoint
    });
  }

  okHandler(color, alphaValue) {
    const rgbaColor = Color(color);
    this.closeColorPicker();
    this.updatePainPointColor(this.state.activePainPoint.id, rgbaColor, alphaValue);
  }

  updatePainPointColor(id, color, value){
    let newColor = {
      color_r: color.red(),
      color_g: color.green(),
      color_b: color.blue(),
    }
    this.props.dispatch(patchAnnotation(id, newColor));
  }

  deletePainPoint(point){
    this.props.dispatch(deleteAnnotation(point.id));
  }

  setCurrentTime(timestamp) {
    if(this.videoPlayer !== null){
      this.videoPlayer.current.currentTime = timestamp;
      // this.videoPlayer.current.play();
    }
  }

  render() {
    const { 
      colorPickerSelectedSettings, 
      colorPickerIsOpen, 
      modalSelectedSettings, 
      modalIsOpen,
      videoDuration 
    } = this.state;

    // const severityOptions = [
    //   { key: 's0', text: '0', value: 0 },
    //   { key: 's1', text: '1', value: 1 },
    //   { key: 's2', text: '2', value: 2 },
    //   { key: 's3', text: '3', value: 3 },
    //   { key: 's4', text: '4', value: 4 },
    //   { key: 's5', text: '5', value: 5 },
    // ]

    // const categoryOptions = [
    //   { key: 'cat1', text: '1', value: 1 },
    //   { key: 'cat2', text: '2', value: 2 }
    // ]
  
    let row = this.props.painpointArray.map(painpoint => {

      return(
        <Table.Row className='row' key={painpoint.id}>
          <Table.Cell className='color'>
            <LabelColor
              className='labelColor'
              clickHandler={() => { this.openColorPicker(defaultColorPicker, painpoint);}}
              red={painpoint.color_r}
              green={painpoint.color_g}
              blue={painpoint.color_b}
              alpha={1}
              />
          </Table.Cell>
          <Table.Cell> 
            <button onClick={() => { this.setCurrentTime(painpoint.timestamp);}}>
              {secondsToHms(painpoint.timestamp)}
            </button> 
          </Table.Cell>
          <Table.Cell>{painpoint.name}</Table.Cell>
          <Table.Cell>
            {/* <Dropdown options={categoryOptions} scrolling simple item/> */}
            {painpoint.annotation_type_id}
          </Table.Cell>
          <Table.Cell>
            {/* <Dropdown scrolling options={severityOptions} /> */}
            {painpoint.severity}
          </Table.Cell>
          <Table.Cell>{`${painpoint.duration}ms`}</Table.Cell>
          <Table.Cell className='buttons'>
            <Icon name='edit' size='large' onClick={() => { this.openModal(defaultColors, 'edit', painpoint); }}/>
            <Icon name='trash' size='large' onClick={() => { this.deletePainPoint(painpoint); }}/>
          </Table.Cell>
        </Table.Row>
      )
    })

    return (
      
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column  width={16}>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video width='100%' key={this.props.url} ref={this.videoPlayer} controls>
                <source src={this.props.url} type='video/mp4'/>
              </video>
              <div id='painpointbar'>
                {
                  this.props.painpointArray.map(painpoint => {
                    return(<div key={painpoint.id} className='painpoint' style={{
                      marginLeft: `${painpoint.timestamp / videoDuration * 100}%`,
                      width: `${painpoint.duration / videoDuration / 10}%`,
                      backgroundColor: `rgb(${painpoint.color_r},${painpoint.color_g},${painpoint.color_b})`
                    }}/>)
                })
                }
              </div>
              <Table celled className='timestampTable'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Label</Table.HeaderCell>
                    <Table.HeaderCell>Timestamp</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Category</Table.HeaderCell>
                    <Table.HeaderCell>Severity</Table.HeaderCell>
                    <Table.HeaderCell>Duration</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {row}
                </Table.Body>
              </Table>
              {this.props.url === '' ? null :
                <Button icon='plus' content='Add pain point' onClick={() => {
                  this.openModal(defaultColors, 'create');
                }}/> 
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <PainPointModal
          className="colorPicker"
          isOpen={modalIsOpen}
          selectedSettings={modalSelectedSettings}
          onRequestClose={this.closeModal}
          okHandler={this.okHandler}
          timestamp={this.videoPlayer.current != null ? this.videoPlayer.current.currentTime : 0}
          mode={this.state.modalMode}
          activePainpoint={this.state.activePainPoint}
        />
        <ColorPicker
          className="colorPicker"
          isOpen={colorPickerIsOpen}
          selectedSettings={colorPickerSelectedSettings}
          onRequestClose={this.closeColorPicker}
          okHandler={this.okHandler}
        />
      </div>
        
    )
  }
}

function secondsToHms(d) {

  let h = Math.floor(d / 3600);
  let m = Math.floor(d % 3600 / 60);
  let s = Math.floor(d % 3600 % 60);

  let hDisplay = h > 0 ? (h > 10 ? `${h}:` : `0${h}:`) : "00:";
  let mDisplay = m > 0 ? (m > 10 ? `${m}:` : `0${m}:`) : "00:";
  let sDisplay = s > 0 ? (s > 10 ? `${s}` : `0${s}` ) : "00";

  return hDisplay + mDisplay + sDisplay; 
}

export default connect(state => {
  let url = ''
  let painpointArray = [];
  let annotations = state.analysis.single.annotations;
  let selectedParticipation = null;
  let activeLayerId = null;

  if(state.analysis.data.video.length > 0){
    selectedParticipation = state.analysis.single.participations[0].id;
    activeLayerId = state.analysis.single.activeLayerId;

    url = state.analysis.data.video[0].url;
    annotations.forEach(annotation => {
      if(annotation.participation_id === selectedParticipation){
        painpointArray.push(annotation);
      }
    });
    
  }
  return{
    url,
    painpointArray,
    annotations,
    activeLayerId
  };
})(Video);


// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/Video.js